import React from "react";
import PdfToOfficeConverter from "../../components/PdfToOfficeConverter";

const PdfToExcel = () => (
  <PdfToOfficeConverter
    target="Excel"
    title="Convert PDF to Excel"
    description="Extract PDF tables into an editable XLSX file."
  />
);

export default PdfToExcel;
